export default __webpack_public_path__ + "static/media/sp-sbo-boy.87f598ad.webp";